<div class="mobile-alternative-bid" *ngIf="isMobile || showAlternativeBidForm">
  <!-- Header -->
  <div class="header">
    <div class="icon-circle">
      <i class="fa-solid fa-tag fa-rotate-90"></i>
    </div>
    <span class="title">ENVIAR OFERTA PERSONALIZADA</span>
  </div>

  <!-- Body -->
  <form class="body" #alternativeBidFormMobile="ngForm" (ngSubmit)="onClickSend(alternativeBidFormMobile)">
    <label class="input-label">VALOR DA PROPOSTA</label>
    
    <div class="value-input-container">
      <mat-form-field appearance="fill" class="large-value-form-field">
        <span matPrefix class="currency">R$</span>
        <input
          matInput
          type="tel"
          currencyMask
          [options]="{ prefix: '', thousands: '.', precision: 0, allowNegative: false }"
          [(ngModel)]="alternativeBid.value"
          class="large-value-input"
          #altBidValueMobile="ngModel"
          name="altBidValueMobile"
          required
        />
      </mat-form-field>
    </div>

    <div class="summary">
      <div class="summary-row">
        <span class="label">Valor da oferta:</span>
        <span class="value">R$ {{ alternativeBid.value | number : "1.0-0" }}</span>
      </div>
      <div class="summary-row">
        <span class="label">Fee plataforma:</span>
        <span class="value">R$ {{ calculateCommissionValue() | number : "1.2-2" }}</span>
      </div>
    </div>

    <div class="total-box">
      <div class="total-label">Total estimado da operação:</div>
      <div class="total-value">R$ {{ calculateTotalOperation() | number : "1.0-0" }}</div>
      <div class="total-note">
        O valor da fee da plataforma é estimado e só será cobrado caso o veículo seja comprado.
      </div>
    </div>

    <button type="submit" class="btn btn-primary btn-rounded btn-block btn-submit" [disabled]="loading">
      ENVIAR OFERTA PERSONALIZADA
    </button>

    <div class="back-link" (click)="triggerBackToStandard()">
      <i class="material-icons">west</i> Voltar para oferta padrão
    </div>
  </form>
</div>

<div
  class="new-layout-box-arrematar"
  *ngIf="!isMobile && vehicle?.active && !vehicle?.hasBids && user && user.isDealer() && vehicle.bidOption !== 'NONE' && !vehicle.ignorePersonalizedOffers"
>
  <div class="container-new-offer">
    <div class="row title-box d-flex align-items-center">
      <div class="col-md-2">
        <i class="admin-icon-balao-dolar" style="margin-right: 8px"></i>
      </div>
      <div class="col-10">
        <div class="row">
          <div class="col-md-12"><span class="title-other-value">PENSOU EM OUTRO VALOR? </span></div>
          <div class="col-md-12"><span class="title-alternative-bid">ENVIE UMA OFERTA PERSONALIZADA!</span></div>
        </div>
      </div>
    </div>
    <div class="success" *ngIf="alternativeBidSuccess">Proposta enviada com sucesso!</div>
    <div class="row" *ngIf="alternativeBidErrorMessage">
      <div class="col-12 warning-box">
        <div class="final-bid-error">
          <i class="material-icons">warning</i>{{ alternativeBidErrorMessage }}
          <ng-container *ngIf="showLatePaymentLink"
            ><a [routerLink]="['/arrematar/arrematados']" [queryParams]="latePaymentQueryParams">Veja aqui</a> seus veículos com fee plataforma
            pendente.</ng-container
          >
        </div>
      </div>
    </div>
  </div>
  <form
    *ngIf="!alternativeBidErrorMessage && !alternativeBidSuccess"
    name="alternativeBidForm"
    (ngSubmit)="onClickSend(alternativeBidForm)"
    #alternativeBidForm="ngForm"
  >
    <div class="row align-items-center">
      <div class="col-12 value-new-offer">
        <mat-form-field>
          <span matPrefix class="currency-symbol">R$</span>
          <input
            matInput
            currencyMask
            name="altBidValue"
            type="tel"
            [max]="vehicle?.finishValue - 1"

            [options]="{ prefix: '', thousands: '.', precision: 0, allowNegative: false }"
            [(ngModel)]="alternativeBid.value"
            required
            #altBidValue="ngModel"
          />

          <mat-error *ngIf="altBidValue.errors?.required">Defina um valor para esta proposta </mat-error>
          <mat-error *ngIf="!altBidValue.errors?.required && altBidValue.errors?.max"
            >Proposta inválida. Tente novamente com um valor abaixo de R$ {{ vehicle.finishValue | number }}.
          </mat-error>

        </mat-form-field>
      </div>

      <div class="col-12 btn-send-alternative-bid">
        <button type="submit" class="btn btn-branded4 btn-rounded btn-block fs-12" [disabled]="loading">ENVIAR</button>
      </div>
    </div>
  </form>
</div>
